import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


function BankIndex() {
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    let companyid = companyId;
    if (isSuperAdmin == true && companyId == superCompanyId) {
        companyid = 0;
    }


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();

            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    // useEffect(() => {
    //     setLoading(true);
    //     fetchData('BankApi', `/${companyId}`, token)
    //         .then((response) => {
    //             if (response.responseCode === '1111') {
    //                 console.log(response);
    //                 setData(response.response_data);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Bank Details:', error);
    //         })
    //         .finally(() => {
    //             setLoading(false); // Hide loading screen
    //         });
    // }, []);

useEffect(() => {
    fetchtableData();

  }, []);

  const fetchtableData = async () => {
    fetchData('BankApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching bank Details:', error);
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">

            <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                    BANK
                </h6>

                <div className='flex items-center mt-2 md:mt-0 md:ml-4'>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '150px' }}
                        />
                    )}
                </div>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <Tooltip title="Create New Bank">

                    <Button
                        style={{ backgroundColor: 'rgb(87, 141, 218)', color: 'white', height: '26px', marginRight: '8px', marginLeft: '5px' }}
                        className="linkcolor"
                        component={Link}
                        to="/BankCreate"
                    >
                        Create
                    </Button>

                </Tooltip>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#123458' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>Bank Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>Branch </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>Ifsc Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>Contact Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'white', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase' }}>ACTIONS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'white' }}>
                            {filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#D4EBF8' },
                                        transition: 'background-color 0.3s ease-in-out'
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        {item.accountName}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        {item.branchName}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        {item.ifscCode}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        {item.contactNumber}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>
                                        <Tooltip title="Edit">
                                        <Link to={`/bankEdit/${item.id}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'red', height: '20px' }} />
                                            </IconButton>
                                            
                                        </Link>
</Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default BankIndex;

